export const subjectLineForClientAndProgram = (clientName: string, programName: string, context?: string) => {
  if (context) {
    return `${clientName} | ${context} for ${programName}`;
  } else {
    return `${clientName} | ${programName}`;
  }
};
